<template>
  <div
    style="height: 615px"
    ref="certificatesCompanyTab"
    :key="keyCounter"
    class="tw-relative"
  >
    <BaseLoader v-if="localLoading" style="z-index: 100"></BaseLoader>

    <div class="tw-flex tw-justify-between tw-my-[15px]">
      <div class="tw-flex tw-gap-[10px] tw-items-center">
        <button class="tw-app-btn-primary-outline" @click="setAddCertificate()">
          <img
            :src="require(`@/assets/icons/add.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Добавить
        </button>
        <AddCertificate
          @update="getWithFilter()"
          :modalInfo="modalInfo"
          :edit="addCertificateModalEdit"
        />

        <button
          class="tw-app-btn-primary-outline"
          @click="setRemoveCertificate()"
        >
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Удалить
        </button>
        <RemoveCertificate
          @update="(activeSelectRowsMultiple = []), getWithFilter()"
          :modalInfo="modalInfo"
        />
      </div>
      <TwBasePagination
        :page-count="data.total / data.limit"
        :pagination-params="data"
        :page-range="10"
        :showLimitInput="false"
        :margin-pages="0"
        :click-handler="getWithFilter"
      >
      </TwBasePagination>
    </div>

    <ve-table
      class="rest-style-table"
      style="width: 100%"
      :columns="columns"
      :table-data="data?.rows || []"
      :border-x="true"
      :border-y="true"
      row-key-field-name="employee_sertificates__id"
      :checkbox-option="{
        hideSelectAll: false,
        selectedRowChange: selectedRowChange,
        selectedAllChange: selectedAllChange,
      }"
      :clickHighlight="false"
      :eventCustomOption="eventCustomOption"
      :rowStyleOption="{
        hoverHighlight: true,
      }"
      :cellSelectionOption="{ enable: false }"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import AddCertificate from "./AddCertificate.vue";
import RemoveCertificate from "./RemoveCertificate.vue";
import dayjs from "dayjs";
import { setTimeout } from "core-js";

export default {
  components: {
    VeTable,
    AddCertificate,
    RemoveCertificate,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      keyCounter: 0,
      activeSelectRowsMultiple: [],
      data: {},
      currentPage: 0,
      localLoading: false,
      filters: {},
      addCertificateModalEdit: null,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.addCertificateModalEdit = row.employee_sertificates__id;
              setTimeout(() => this.$modal.show("AddCertificate"), 10);
            },
          };
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
    columns() {
      return [
        {
          field: "",
          key: "a",
          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "employee_sertificates__created_at",
          key: "employee_sertificates__created_at",
          title: "Дата",
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.employee_sertificates__created_at
                  ? dayjs(row.employee_sertificates__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)
                  : ""}
              </span>
            );
          },
        },
        {
          field: "employee_sertificates__fio",
          key: "employee_sertificates__fio",
          title: "ФИО",
          align: "left",
          width: "60%",
        },
        {
          field: "employee_sertificates__level",
          key: "employee_sertificates__level",
          title: "Уровень",
          align: "center",
          width: "8%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.employee_sertificates__level}/10</span>;
          },
        },
        {
          field: "employee_sertificates__passport",
          key: "employee_sertificates__passport",
          title: "Паспорт",
          align: "center",
          width: "10%",
        },
        {
          field: "employee_sertificates__life_to",
          key: "employee_sertificates__life_to",
          title: "Выдан до",
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.employee_sertificates__life_to
                  ? dayjs(row.employee_sertificates__life_to)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)
                  : ""}
              </span>
            );
          },
        },
      ];
    },
  },
  methods: {
    setAddCertificate() {
      this.addCertificateModalEdit = null;
      setTimeout(() => this.$modal.show("AddCertificate"), 10);
    },
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    selectedRowChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    setRemoveCertificate() {
      if (this.activeSelectRowsMultiple?.length) {
        this.$modal.show("RemoveCertificate");
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    getWithFilter(page) {
      const where = Object.entries(this.filters)
        .filter(([, config]) => config.value)
        .map(([field, config]) => ({
          field,
          value:
            config.operator === "like"
              ? `;percent;${config.value};percent;`
              : config.value,
          ...(config.operator && { operator: config.operator }),
        }));
      this.getData(where, page);
    },
    getData(where = [], page = 1) {
      this.localLoading = true;
      GeneralService.get(
        `/super/companies/tab/sertificate/table/list/${this.modalInfo.id}`,
        {
          params: {
            where: JSON.stringify(where),
            page: page,
            limit: 14,
          },
        }
      )
        .then((data) => {
          this.data = data.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.localLoading = false;
        });
    },
  },
};
</script>
